// src/api/simulationService.js
import axiosInstance from "./axiosInstance"; // adjust path as needed

export default {
  /**
   * Trigger an alarm for the given project.
   * POST /simulations/alarm/{project_id}
   */
  
  async createAlarm(projectId, alarmDatetime) {
    // The server expects a JSON body like { alarm_datetime: "2025-01-19T09:25:05.154Z" }
 

    const response = await axiosInstance.post(
      `/simulations/alarm/${projectId}`,
      alarmDatetime
    );
    return response.data; // server returns a string upon success
  },

  /**
   * Get paginated alarms for the given project.
   * GET /simulations/alarm/{project_id}?page=1&size=10
   */
  async getAlarmsForProject(projectId, page = 1, size = 10) {
    const response = await axiosInstance.get(`/simulations/alarm/${projectId}`, {
      params: { page, size },
    });
    // The server returns:
    // {
    //   "total": ...,
    //   "page": ...,
    //   "size": ...,
    //   "items": [
    //       { "id":..., "project_id":..., "alarm_datetime":..., "created_at":... },
    //       ...
    //   ]
    // }
    return response.data;
  },
};
